<div class="document-preview">
  <div class="document-preview-layout">
    @if (preview.type === documentType.PICTURE && previewType === 'PICTURE') {
      <img class="image" [src]="serverRoot+'/client/resource/archive/' + preview.previewResourceUUID + '?type=thumb'"
        height="100" />
    }

    @if (preview.type === documentType.PICTURE &&  previewType === 'PDF') {
      <sc-icon iconClass="fa-file-pdf file-type-icon"
      ></sc-icon>
    }

    @if (preview.type === documentType.PICTURE &&  previewType === 'UNKNOWN') {
      <sc-icon iconClass="fa-file file-type-icon"
      ></sc-icon>
    }

    @if (preview.type === documentType.PICTURE && preview.title) {
      <div class="title">
        {{preview.title | slice:0:100}} {{preview.source}}
      </div>
    }
    @if (preview.type === documentType.APP_DOCUMENT && (preview.title || preview.titleDictionaryKey)) {
      <div class="title"
        >
        <sc-dictionary-label [dictionaryKey]="preview.titleDictionaryKey"></sc-dictionary-label>
      </div>
    }
    @if (preview.type === documentType.APP_DOCUMENT && preview.subTitle) {
      <div class="subtitle">
        {{preview.subTitle | slice:0:100}}
      </div>
    }
  </div>
  <div class="document-infos">
    <sc-padding>
      <sc-flex>
        <sc-content-spacer grow></sc-content-spacer>
        @if (preview.deletedInTime) {
          <sc-icon iconClass="fa-trash"></sc-icon>
        }
        @if (preview.source === 'Yard') {
          <sc-content-spacer></sc-content-spacer>
        }
        @if (preview.source === 'Yard' && preview.publishedInTime) {
          <sc-icon iconClass="fa-cloud-arrow-up"></sc-icon>
        }
        @if (preview.source === 'time_carrier_booking_document') {
          <sc-content-spacer></sc-content-spacer>
        }
        @if (preview.source === 'time_carrier_booking_document') {
          <sc-icon iconClass="fa-cloud-arrow-down"></sc-icon>
        }
      </sc-flex>
    </sc-padding>
  </div>
</div>
